// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mainUrl: 'https://primisproject.regione.veneto.it',
  endpoint: 'https://primisproject.regione.veneto.it/primis-be-1.0.0/',
  mapApiKey: 'AIzaSyB8vptN3iHX5ojegx7jo9OcFsEvlwvfjJE',
  sizeLimit: {
    video: 500000000,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
